
define('eteration/widgets/ui-selectpicker',['knockout','bootstrap.select'], function(ko){
	
	ko.bindingHandlers.selectpicker = {

		init: function (element, valueAccessor, allBindingsAccessor) {
		  
			var $element = $(element);
			
			var accessor = valueAccessor();
			
			var showSubtext = accessor.showSubtext || false; 
			
			var liveSearch = accessor.liveSearch || false; 
			
			var dropupAuto = accessor.dropupAuto || false; 

			var width = accessor.width || '100%'; 
			
			var size = accessor.size || 10; 
			
			$element.addClass('selectpicker').selectpicker({showSubtext: showSubtext, liveSearch: liveSearch, dropupAuto: dropupAuto, size: size, width: width});
	
			
			var doRefresh = function() {
				$element.selectpicker('refresh');
			};
	
			// KO 3 requires subscriptions instead of relying on this binding's update function firing when any other binding on the element is updated.
			// Add them to a subscription array so we can remove them when KO tears down the element.  Otherwise you will have a resource leak.
			 
			var subscriptions = [];
	
			var addSubscription = function(bindingKey) {
	
				var targetObs = allBindingsAccessor.get(bindingKey);
		
				if ( targetObs && ko.isObservable(targetObs)) {
					subscriptions.push( targetObs.subscribe(doRefresh) );
				}
			
			};
			
			addSubscription('options');
			addSubscription('value');           // Single
			addSubscription('selectedOptions'); // Multiple
	 
			ko.utils.domNodeDisposal.addDisposeCallback(element, function() { 
				while(subscriptions.length) {
					subscriptions.pop().dispose();
				}
			});
		},
		
		update: function (element, valueAccessor, allBindingsAccessor) {
			//NO-OP FOR NOW
		}
		
	};
	

	ko.bindingHandlers.selectPicker = {
		    init: function (element, valueAccessor, allBindingsAccessor) {
		        if ($(element).is('select')) {
		            if (ko.isObservable(valueAccessor())) {
		                if ($(element).prop('multiple') && $.isArray(ko.utils.unwrapObservable(valueAccessor()))) {
		                    // in the case of a multiple select where the valueAccessor() is an observableArray, call the default Knockout selectedOptions binding
		                    ko.bindingHandlers.selectedOptions.init(element, valueAccessor, allBindingsAccessor);
		                } else {
		                    // regular select and observable so call the default value binding
		                    ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor);
		                }
		            }
		            $(element).addClass('dropdownselect').selectpicker();
		        }
		    },
		    update: function (element, valueAccessor, allBindingsAccessor) {
		        if ($(element).is('select')) {
		            var selectPickerOptions = allBindingsAccessor().selectPickerOptions;
		            if (typeof selectPickerOptions !== 'undefined' && selectPickerOptions !== null) {
		                var options = selectPickerOptions.optionsArray,
		                    isDisabled = selectPickerOptions.disabledCondition || false,
		                    resetOnDisabled = selectPickerOptions.resetOnDisabled || false;
		                var arr = ko.utils.unwrapObservable(options);
		                if (arr && arr.length > 0) {
		                    // call the default Knockout options binding
		                    ko.bindingHandlers.options.update(element, options, allBindingsAccessor);
		                }
		                if (isDisabled && resetOnDisabled) {
		                    // the dropdown is disabled and we need to reset it to its first option
//		                    $(element).selectpicker('val', $(element).children('option:first').val());
		                }
		                $(element).prop('disabled', isDisabled);
		            }
		            if (ko.isObservable(valueAccessor())) {
		                if ($(element).prop('multiple') && $.isArray(ko.utils.unwrapObservable(valueAccessor()))) {
		                    // in the case of a multiple select where the valueAccessor() is an observableArray, call the default Knockout selectedOptions binding
		                    ko.bindingHandlers.selectedOptions.update(element, valueAccessor, allBindingsAccessor);
		                } else {
		                    // call the default Knockout value binding
		                    ko.bindingHandlers.value.update(element, valueAccessor, allBindingsAccessor);
		                }
		            }

		            $(element).selectpicker('refresh');
		        }
		    }
		};
	
});
